export default {
  inputBorder: '1px solid'
}



// WEBPACK FOOTER //
// ./src/core/theme/borders.js